module.exports = __webpack_public_path__ + "static/fonts/AppleSDGothicNeoEB.c41edc8.woff";